import { CellModifiers } from '../types/morningstar.types';

/**
 * Determines if a position should be displayed in bold based on row and column positions
 * @param position - Current position to check
 * @param boldRow - Row position that should be bold
 * @param boldCol - Column position that should be bold
 * @returns Boolean indicating if position should be bold
 */
export const isBoldPosition = (
  position: string,
  boldRow?: string | null,
  boldCol?: string | null,
): boolean => {
  if (!position) return false;
  const normalizedPosition = position.toLowerCase();
  const normalizedRow = boldRow?.toLowerCase();
  const normalizedCol = boldCol?.toLowerCase();
  return (
    normalizedPosition === normalizedRow || normalizedPosition === normalizedCol
  );
};

/**
 * Generates class map for grid cells with modifiers
 * @param baseClass - Base CSS class name
 * @param modifiers - Object containing modifier conditions
 * @returns Object with CSS class mappings
 */
export const getCellClassMap = (
  baseClass: string,
  modifiers: CellModifiers,
): Record<string, boolean> => ({
  [baseClass]: true,
  ...Object.entries(modifiers).reduce<Record<string, boolean>>(
    (acc, [modifier, condition]) => ({
      ...acc,
      [`${baseClass}--${modifier}`]: condition,
    }),
    {},
  ),
});
